import { Component, Vue } from "vue-property-decorator";
import { mapState } from "vuex";
import { ClientDDL, ClientInfo } from "@/views/base/base.types";
import { PatientSummary } from "@/views/summary/summary.types";
import { 
  WatchCharging,
  WatchWorn,
  BiometricCollectionCount,
  Imei
} from "@/views/sidebar/watch-statistics/watch-statistics.types";

@Component({
  computed: {
    ...mapState("WatchStatistics", [
      "imeis",
      "watchWorn",
      "watchCharging",
      "biometricRecordCount"
    ]),
    ...mapState("Base", [
      "selectedClientDDL",
      "clientInfo"
    ]),
    ...mapState("Summary", [
      "selectedPatientSummary"
    ])
  }
})
export default class WatchStatisticsMixin extends Vue {
  clientInfo!: ClientInfo[];
  selectedPatientSummary!: PatientSummary;
  imeis!: Imei[];
  selectedClientDDL!: ClientDDL;
  watchWorn!: WatchWorn;
  watchCharging!: WatchCharging;
  biometricRecordCount!: BiometricCollectionCount;

  pickDate = new Date();

  get selectedName() {
    return `${this.selectedPatientSummary.firstName} ${this.selectedPatientSummary.lastName}`;
  }

  get selectedClient() {
    return this.clientInfo.find(
      item => item.clientId === this.selectedClientDDL.value
    ) ?? new ClientInfo;
  }

  getInitials(name: string): string {
    if (!name) return '';
    const words = name.split(' ');
    return words.length >= 2
      ? words[0][0] + words[1][0]
      : words[0][0];
  }
}